const NO_MATCH = '-'

const projectClauses = (ref: string) => {
	const [client, domain, slug] = ref.split('/')

	return [
		{ field: 'project.slug', comparator: 'eq', value: slug || NO_MATCH },
		{ field: 'project.domain.slug', comparator: 'eq', value: domain || NO_MATCH },
		{ field: 'project.domain.client.slug', comparator: 'eq', value: client || NO_MATCH },
	] as const
}

export { NO_MATCH, projectClauses }
